export const DEFAULT_OTP_COOLDOWN_SECONDS = 0;

const toPositiveSeconds = (value: unknown) => {
  const seconds = Number(value);
  return Number.isFinite(seconds) && seconds > 0 ? Math.ceil(seconds) : 0;
};

export const getOtpCooldownSeconds = (data: any) =>
  toPositiveSeconds(data?.cooldownSeconds) || DEFAULT_OTP_COOLDOWN_SECONDS;

export const getOtpRetryAfterSeconds = (data: any) =>
  toPositiveSeconds(data?.retryAfterSeconds);

export const formatOtpCountdown = (seconds: number) => {
  const normalized = Math.max(0, Math.ceil(seconds));

  if (normalized < 60) {
    return `${normalized}s`;
  }

  const minutes = Math.floor(normalized / 60);
  const remainder = normalized % 60;

  return remainder ? `${minutes}m ${remainder}s` : `${minutes}m`;
};
